/* istanbul ignore file */
import React from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import GIEButton from '../../components/GIEButton/GieButton';
import GIELink from "../../components/GIELink/GIELink";
import EquipmentCard from "../../components/EquipmentChoice/EquipmentCard";

export default class Offer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      value: '',
    }
  }

  handleChange = (event) => {
    this.setState({value: event.target.value})
  }

  next = () => {
    if (this.state.value.length) {
      this.props.next(this.state.value);
    }
  }

  render() {
    return (
      <div className="d-flex flex-column gap-4">
        <EquipmentCard emit={() => this.setState({value: 'security'})}
                       checked={this.state.value === 'security'}>
          <h5 className="d-inline-block color-primary-lighter">Offre sécurité</h5>
          <ul className="list-unstyled">
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Une visite d’entretien</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Réglage de l’appareil</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Dépannage 7j/7 de 7h30 à 20h et réparations facturés en sus</span>
            </li>
          </ul>
        </EquipmentCard>

        <EquipmentCard emit={() => this.setState({value: 'comfort'})}
                       checked={this.state.value === 'comfort'}>
          <h5 className="d-inline-block color-primary-lighter">Offre confort</h5>
          <ul className="list-unstyled">
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Une visite d’entretien</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Réglage de l’appareil</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Accès gratuit au dépannage 7j/7 de 7h30 à 20h</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Réparations facturées en sus</span>
            </li>
          </ul>
        </EquipmentCard>

        <EquipmentCard emit={() => this.setState({value: 'tranquility'})}
                       checked={this.state.value === 'tranquility'}>
          <h5 className="d-inline-block color-primary-lighter">Offre tranquillité</h5>
          <ul className="list-unstyled">
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Une visite d’entretien</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Réglage de l’appareil</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Accès gratuit au dépannage 7j/7 de 7h30 à 20h</span>
            </li>
            <li>
              <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
              <span>Remplacement gratuit des pièces nécessaires au bon fonctionnement de l’appareil</span>
            </li>
            <li>
              <span>* Cette offre est réservée aux chaudières de moins de deux ans et limitée à 5 ans de contrat.</span>
            </li>
          </ul>
        </EquipmentCard>

        <div className="d-flex justify-content-between align-items-center mt-4">
          <GIELink href="javascript:void(0)" onClick={this.props.previous} arrowBefore>Précédent</GIELink>
          <GIEButton onClick={this.next} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
          <div></div>
        </div>
      </div>
    );
  }
}
